import { createContext, useContext } from 'react';
import type { BrandOffersAdminAuthContextType } from './BrandOffersAdminAuthContext.types';

export const BrandOffersAdminAuthContext = createContext<
  BrandOffersAdminAuthContextType | undefined
>(undefined);

export const useBrandOffersAdminAuth = (): BrandOffersAdminAuthContextType => {
  const context = useContext(BrandOffersAdminAuthContext);
  if (context === undefined) {
    throw new Error(
      'useBrandOffersAdminAuth must be used within a BrandOffersAdminAuthProvider'
    );
  }
  return context;
};
